/* ==========================================================================
   POESPAS — 1 + 1 gratis: tweede panty gaat vanzelf mee   (Claude, 07-09-2026)

   WAT DOET DIT
   Het aantal van een 1+1-artikel wordt altijd op een even getal gehouden:
     1 in de mand  -> wordt 2   (de tweede is gratis)
     3 in de mand  -> wordt 4
     van 2 naar 1  -> wordt 0   (het paar gaat samen weg)
     van 4 naar 3  -> wordt 2
   De richting bepaalt de afronding: omhoog naar boven, omlaag naar beneden.

   DE KORTING ZIT HIER NIET IN.
   Dat doet de automatische Shopify-korting "Tweede panty Emma gratis"
   (Koop 1, krijg 1 gratis). Dit script regelt alleen het aantal. Staat die
   korting uit, dan betaalt de klant gewoon twee panty's.

   NA DE ACTIE WEG TE HALEN: dit bestand en de regel in layout/theme.liquid
   (zoek op pp-duo-panty).
   ========================================================================== */
(function () {
  'use strict';

  // Artikelen waarvoor 1+1 geldt. Product-id, dus alle varianten in één keer.
  var DUO_PRODUCT_IDS = [
    8519448592522   // Panty Emma | Zwart gevoerd | 200 Den — EAN 6097728558597
  ];

  var bezig = false;
  var wachtrij = false;
  var vorigeStand = {};    // product-id -> laatst geziene aantal, bepaalt de richting
  var geblokkeerd = {};    // product-id -> aantal dat we niet konden bijstellen (voorraad op)

  function haalMand() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function voegToe(variantId, aantal) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: aantal }] })
    }).then(function (r) { return r.json(); });
  }

  function zetAantal(lineKey, aantal) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: aantal })
    }).then(function (r) { return r.json(); });
  }

  function sync() {
    if (bezig) { wachtrij = true; return Promise.resolve(); }
    bezig = true;

    return ronde()
      .catch(function () {})
      .then(function () {
        bezig = false;
        if (wachtrij) { wachtrij = false; return sync(); }
      });
  }

  function ronde() {
    return haalMand().then(function (mand) {
      var werk = [];

      DUO_PRODUCT_IDS.forEach(function (pid) {
        var regels = (mand.items || []).filter(function (i) { return i.product_id === pid; });
        var huidig = regels.reduce(function (n, i) { return n + i.quantity; }, 0);
        var vorig = vorigeStand[pid];

        if (huidig === 0 || huidig % 2 === 0) {
          vorigeStand[pid] = huidig;    // niets te doen, stand onthouden
          delete geblokkeerd[pid];
          return;
        }

        // Eerder al vergeefs geprobeerd bij dit aantal (voorraad op). Dan met rust
        // laten: anders zou de volgende ronde het als 'klant gaat omlaag' lezen en
        // het artikel alsnog uit de mand gooien.
        if (geblokkeerd[pid] === huidig) {
          vorigeStand[pid] = huidig;
          return;
        }

        // Oneven: bijstellen in de richting waarin de klant bewoog.
        // Onbekende beginstand (verse pagina) telt als omhoog: de tweede is gratis.
        var omhoog = (vorig === undefined) || huidig > vorig;
        var doel = omhoog ? huidig + 1 : huidig - 1;

        werk.push({ regels: regels, huidig: huidig, doel: doel, pid: pid });
      });

      if (!werk.length) return;

      var keten = Promise.resolve();
      werk.forEach(function (w) {
        keten = keten.then(function () { return pasAan(w); });
      });
      return keten.then(verversDrawer);
    });
  }

  // De 1+1-korting laat Shopify het artikel in een betaalde en een gratis regel
  // uiteenvallen, en die indeling verandert bij elke wijziging. Daarom werken we
  // niet met absolute aantallen per regel: omhoog gaat via een gewone toevoeging
  // (optellen is voorspelbaar), omlaag door de regels af te bouwen.
  function pasAan(w) {
    if (w.doel > w.huidig) {
      var variantId = w.regels[0].variant_id;
      return voegToe(variantId, w.doel - w.huidig).then(function () { return meetNa(w); });
    }

    return bouwAf(w.pid, w.doel, 0).then(function () { return meetNa(w); });
  }

  // Stap voor stap afbouwen, en telkens opnieuw kijken hoe de mand er nú uitziet.
  // Shopify kan de regels tussendoor herschikken, waardoor vooraf verzamelde
  // regelsleutels niet meer kloppen.
  function bouwAf(pid, doel, pogingen) {
    if (pogingen > 12) return Promise.resolve();

    return haalMand().then(function (mand) {
      var regels = (mand.items || []).filter(function (i) { return i.product_id === pid; });
      var huidig = regels.reduce(function (n, i) { return n + i.quantity; }, 0);
      if (!regels.length || huidig <= doel) return;

      var laatste = regels[regels.length - 1];
      var eraf = Math.min(huidig - doel, laatste.quantity);

      return zetAantal(laatste.key, laatste.quantity - eraf).then(function () {
        return bouwAf(pid, doel, pogingen + 1);
      });
    });
  }

  // Kijken waar we werkelijk op uitkwamen. Lukte het niet, dan hield de voorraad
  // het tegen: onthouden, zodat we het niet blijven proberen en het aantal ook
  // niet alsnog omlaag duwen.
  function meetNa(w) {
    return haalMand().then(function (mand) {
      var na = (mand.items || []).filter(function (i) { return i.product_id === w.pid; })
        .reduce(function (n, i) { return n + i.quantity; }, 0);

      if (na !== w.doel) geblokkeerd[w.pid] = na;
      else delete geblokkeerd[w.pid];

      vorigeStand[w.pid] = na;
    });
  }

  /* ---------- winkelmandlade bijwerken ---------- */

  function verversDrawer() {
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));

    return fetch('/cart?section_id=api-cart-items', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doos = document.createElement('div');
        doos.innerHTML = html;

        vervang(doos, '[data-api-line-items]', '[data-items-holder]');
        vervang(doos, '[data-api-upsell-items]', '[data-pair-products-holder]');
        vervang(doos, '[data-api-cart-price]', '[data-cart-price-holder]');

        return haalMand().then(function (mand) {
          var holder = document.querySelector('[data-items-holder]');
          if (holder) holder.classList.toggle('hidden', mand.item_count === 0);

          document.querySelectorAll('[data-cart-items-qty]').forEach(function (el) {
            el.classList.toggle('hidden', mand.item_count === 0);
            el.textContent = mand.item_count === 1 ? '1 artikel' : mand.item_count + ' artikelen';
          });

          document.querySelectorAll('[data-cart-total-price]').forEach(function (el) {
            el.textContent = euro(mand.total_price);
          });

          document.dispatchEvent(new CustomEvent('theme:cart:loaded', { bubbles: true }));
        });
      })
      .catch(function () {});
  }

  function euro(centen) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(centen / 100);
    } catch (e) {
      return '€ ' + (centen / 100).toFixed(2).replace('.', ',');
    }
  }

  function vervang(bron, vanSel, naarSel) {
    var nieuw = bron.querySelector(vanSel);
    var doel = document.querySelector(naarSel);
    if (nieuw && doel) doel.innerHTML = nieuw.innerHTML;
  }

  /* ---------- aanhaken ---------- */

  ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(sync, 250); });
  });

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function wikkelFetch() {
    var huidig = window.fetch;
    if (!huidig || huidig._ppDuo) return;
    var basis = huidig;
    var nieuw = function () {
      var p = basis.apply(this, arguments);
      try {
        var a0 = arguments[0];
        var url = (a0 && a0.url) ? a0.url : a0;
        if (CART_RE.test(String(url)) && !bezig) {
          p.then(function () { setTimeout(sync, 300); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
    nieuw._ppDuo = true;
    window.fetch = nieuw;
  }

  function wikkelXhr() {
    var proto = XMLHttpRequest.prototype;
    if (proto.open._ppDuo) return;
    var basis = proto.open;
    var nieuw = function (method, url) {
      try {
        if (CART_RE.test(String(url))) {
          this.addEventListener('load', function () { if (!bezig) setTimeout(sync, 300); });
        }
      } catch (e) {}
      return basis.apply(this, arguments);
    };
    nieuw._ppDuo = true;
    proto.open = nieuw;
  }

  wikkelFetch(); wikkelXhr();
  window.addEventListener('load', function () {
    wikkelFetch(); wikkelXhr();
    setTimeout(function () { wikkelFetch(); wikkelXhr(); }, 1500);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  window.__ppDuoPanty = { sync: sync, ids: DUO_PRODUCT_IDS, versie: 'v1' };
})();
